export const ReviewIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#FFF5DB" />
    <path
      d="M20.2203 16.6011V8.66342V7H11.8886L8 10.8886V23.1016H16.3901C17.0905 23.7874 18.0535 24.2106 19.1114 24.2106C21.2563 24.2106 23 22.4669 23 20.3219C23 18.571 21.8254 17.0827 20.2203 16.6011ZM9.11625 21.9927V11.9976H13.0049V8.10895H19.1114V16.4406C16.9664 16.4406 15.2228 18.1843 15.2228 20.3292C15.2228 20.9275 15.3614 21.4893 15.5948 21.9927H9.11625ZM19.1114 23.6634C17.2729 23.6634 15.7772 22.1751 15.7772 20.3292C15.7772 18.4907 17.2656 16.9951 19.1114 16.9951C20.9499 16.9951 22.4455 18.4834 22.4455 20.3292C22.4455 22.1678 20.9499 23.6634 19.1114 23.6634Z"
      fill="#E7AB12"
    />
    <path
      d="M16.8848 20.3292H18.5482V22.5544H19.6571V20.3292H21.3206L19.1027 18.1113L16.8848 20.3292Z"
      fill="#E7AB12"
    />
    <path
      d="M10.7754 13.1006H17.4437V13.6551H10.7754V13.1006Z"
      fill="#E7AB12"
    />
    <path d="M10.7754 14.2285H17.4437V14.783H10.7754V14.2285Z" fill="#E7AB12" />
    <path
      d="M10.7754 15.3281H17.4437V15.8826H10.7754V15.3281Z"
      fill="#E7AB12"
    />
    <path d="M10.7754 16.4414H14.664V16.9959H10.7754V16.4414Z" fill="#E7AB12" />
  </svg>
);

export const CrossIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_413_8900)">
      <path
        d="M9.99935 18.3337C5.39685 18.3337 1.66602 14.6028 1.66602 10.0003C1.66602 5.39783 5.39685 1.66699 9.99935 1.66699C14.6018 1.66699 18.3327 5.39783 18.3327 10.0003C18.3327 14.6028 14.6018 18.3337 9.99935 18.3337ZM9.99935 16.667C11.7675 16.667 13.4632 15.9646 14.7134 14.7144C15.9636 13.4641 16.666 11.7684 16.666 10.0003C16.666 8.23222 15.9636 6.53652 14.7134 5.28628C13.4632 4.03604 11.7675 3.33366 9.99935 3.33366C8.23124 3.33366 6.53555 4.03604 5.2853 5.28628C4.03506 6.53652 3.33268 8.23222 3.33268 10.0003C3.33268 11.7684 4.03506 13.4641 5.2853 14.7144C6.53555 15.9646 8.23124 16.667 9.99935 16.667ZM9.99935 8.82199L12.356 6.46449L13.5352 7.64366L11.1777 10.0003L13.5352 12.357L12.356 13.5362L9.99935 11.1787L7.64268 13.5362L6.46352 12.357L8.82102 10.0003L6.46352 7.64366L7.64268 6.46449L9.99935 8.82199Z"
        fill="#97999B"
      />
    </g>
    <defs>
      <clipPath id="clip0_413_8900">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SuccessIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#ECF9E9" />
    <g clip-path="url(#clip0_956_4318)">
      <path
        d="M15.9993 24.3337C11.3968 24.3337 7.66602 20.6028 7.66602 16.0003C7.66602 11.3978 11.3968 7.66699 15.9993 7.66699C20.6018 7.66699 24.3327 11.3978 24.3327 16.0003C24.3327 20.6028 20.6018 24.3337 15.9993 24.3337ZM15.9993 22.667C17.7675 22.667 19.4632 21.9646 20.7134 20.7144C21.9636 19.4641 22.666 17.7684 22.666 16.0003C22.666 14.2322 21.9636 12.5365 20.7134 11.2863C19.4632 10.036 17.7675 9.33366 15.9993 9.33366C14.2312 9.33366 12.5355 10.036 11.2853 11.2863C10.0351 12.5365 9.33268 14.2322 9.33268 16.0003C9.33268 17.7684 10.0351 19.4641 11.2853 20.7144C12.5355 21.9646 14.2312 22.667 15.9993 22.667ZM15.1685 19.3337L11.6327 15.7978L12.811 14.6195L15.1685 16.977L19.8819 12.2628L21.061 13.4412L15.1685 19.3337Z"
        fill="#3DC826"
      />
    </g>
    <defs>
      <clipPath id="clip0_956_4318">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

export const ErrorIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#FEE7E5" />
    <g clip-path="url(#clip0_956_4310)">
      <path
        d="M15.9993 24.3337C11.3968 24.3337 7.66602 20.6028 7.66602 16.0003C7.66602 11.3978 11.3968 7.66699 15.9993 7.66699C20.6018 7.66699 24.3327 11.3978 24.3327 16.0003C24.3327 20.6028 20.6018 24.3337 15.9993 24.3337ZM15.9993 22.667C17.7675 22.667 19.4632 21.9646 20.7134 20.7144C21.9636 19.4641 22.666 17.7684 22.666 16.0003C22.666 14.2322 21.9636 12.5365 20.7134 11.2863C19.4632 10.036 17.7675 9.33366 15.9993 9.33366C14.2312 9.33366 12.5355 10.036 11.2853 11.2863C10.0351 12.5365 9.33268 14.2322 9.33268 16.0003C9.33268 17.7684 10.0351 19.4641 11.2853 20.7144C12.5355 21.9646 14.2312 22.667 15.9993 22.667ZM15.9993 14.822L18.356 12.4645L19.5352 13.6437L17.1777 16.0003L19.5352 18.357L18.356 19.5362L15.9993 17.1787L13.6427 19.5362L12.4635 18.357L14.821 16.0003L12.4635 13.6437L13.6427 12.4645L15.9993 14.822Z"
        fill="#F20F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_956_4310">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);
